import { Pointer } from '@yleisradio/areena-types';
import { useCallback } from 'react';
import { useSWRConfig } from 'swr';
import { isPersonalList } from 'utils/pointer';

function isPersonalListKey(key: unknown): boolean {
  return Array.isArray(key) && isPersonalList(key[0] as Pointer | undefined);
}

/**
 * Returns a function that revalidates the cached card pages of all personal
 * lists (e.g. continue watching, favorites). Mounted lists refetch right away;
 * unmounted ones revalidate when they mount again.
 */
export function useRevalidatePersonalLists(): () => void {
  const { mutate } = useSWRConfig();

  return useCallback(() => {
    mutate(isPersonalListKey);
  }, [mutate]);
}
